import { ChangeEvent, MouseEvent, useEffect, useState } from "react"
import { ArticleResponse, ArticleWithPhoto } from "type"
import axios, { AxiosResponse } from "axios"
import { API_BASE_URL, EDIT_PATH, TIME_DIFFERENCE } from "config"
import { SearchBar } from "component"
import { useNavigate } from "react-router-dom"
import { useDisplayedArticle } from "globalState"
import { Article } from "component/Article"

export const ArticleList = ()=>{
  const navigate = useNavigate()
  const [articles, setArticles] = useState<ArticleResponse[]>([])
  const [, setDisplayedArticle] = useDisplayedArticle()
  let dateMills = new Date().getTime()

  const onDateChange = (evt: ChangeEvent<HTMLInputElement>)=>{
    const dateStr =evt.target.value + ' 00:00' + TIME_DIFFERENCE
    dateMills = new Date(dateStr).getTime()
  }

  const onSearchButtonClick = ()=>{
    fetchArticle(dateMills)
  }

  const onEditButtonClick = (e: MouseEvent, id: string)=>{
    const selectedArticle = articles.filter(v=>v.article.id.toString() === id)[0]
    const displayedArticle: ArticleWithPhoto = {
      article: selectedArticle.article,
      photos: selectedArticle.photos
    }
    setDisplayedArticle(()=>displayedArticle)
    navigate(EDIT_PATH + '/' + id)
  }

  const fetchArticle = async (olderThan : number)=>{
    const res : AxiosResponse<ArticleResponse[]> = await axios.get(API_BASE_URL + '/article',{
      params: {
        olderThan: olderThan
      }
    })
    setArticles(()=>res.data.sort((b,a)=>a.article.createdAt - b.article.createdAt))
  }

  useEffect(()=>{
    fetchArticle(new Date().getTime())
  },[])

  const element = articles.map(v =>{
    return (
      <Article
        key={v.article.id.toString()}
        articleWithPhoto={{article: v.article, photos:v.photos}}
        onEditButtonClick={onEditButtonClick}
      />
    )
  })

  return(
    <>
      <SearchBar onInputChange={onDateChange} onSearchButtonClick={onSearchButtonClick} />
      <div>
        {element}
      </div>
    </>
  )
}